import { tsValidateArray, tsValidateString, tsValidateStringAndNumbersWithDashes } from '@nu-art/ts-common';
import { PermissionDBGroup } from '../../consts.js';
const Validator_ModifiableProps = {
    groups: tsValidateArray({
        groupId: tsValidateStringAndNumbersWithDashes,
    }, false),
};
const Validator_GeneratedProps = {
    __groupIds: tsValidateArray(tsValidateStringAndNumbersWithDashes, false),
    _auditorId: tsValidateString()
};
export const DBDef_PermissionUser = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'permissions--user',
    entityName: 'PermissionUser',
    frontend: {
        group: PermissionDBGroup,
        name: 'user',
    },
    backend: {
        name: 'permissions--user'
    },
    dependencies: {
        '__groupIds': {
            fieldType: 'string[]',
            dbKey: 'permissions--group',
        }
    }
};
//# sourceMappingURL=db-def.js.map